{"rating":"4.9","reviewCount":"141","fetchedAt":"2026-10-19T06:20:01.365Z","source":"place-details"}